import React from 'react';
import { Draggable } from 'react-beautiful-dnd';
import KanbanCard from '../../card';

import styles from './style.module.css';

interface DNDCardProps {
  id: number;
  due_at: string;
  local_task_id: number;
  asset_id: number | object;
  tag_ids: number[];
  tags: object;
  description: string;
  description_html?: string | null;
  priority_id: number;
  index: number;
  canDrag: boolean;
  setActiveTask: () => void;
  moveTaskToFeedback: () => void;
  moveTaskToArchive: () => void;
  getAssignees: () => void;
  isActive: boolean;
  action: string;
  multiSelect: () => void;
  unSelectAll: () => void;
  selectedTaskList: any[];
  asset_type?: string;
  comments: { mention_ids: number[]; read_by_user_ids: number[] }[];
  hasScreenRecording: boolean;
  disableDrag?: boolean;
  viewGuestKanban: boolean;
  guestVisible: boolean;
  title?: string;
  site?: string | null;
  url?: string | null;
  related_to_task_ids: { merged_from: number[]; merged_to: number[] };
  original_copy_text?: string | null;
}

const DNDCard: React.FC<DNDCardProps> = ({
  id,
  due_at,
  local_task_id,
  asset_id,
  tag_ids,
  tags,
  description,
  description_html,
  related_to_task_ids,
  title,
  site,
  url,
  priority_id,
  index,
  canDrag,
  setActiveTask,
  moveTaskToFeedback,
  moveTaskToArchive,
  getAssignees,
  isActive,
  action,
  multiSelect,
  unSelectAll,
  selectedTaskList,
  asset_type,
  comments,
  hasScreenRecording,
  disableDrag,
  viewGuestKanban,
  guestVisible,
  ai_suggested_title,
  original_copy_text
}) => {
  return (
    <Draggable
      draggableId={`${id}`}
      key={`${id}`}
      index={index}
      isDragDisabled={!canDrag || disableDrag}
    >
      {(provided, snapshot) => {
        return (
          <div
            ref={provided.innerRef}
            {...provided.draggableProps}
            className={snapshot.isDragging ? styles.dragging : null}
          >
            <KanbanCard
              id={id}
              due_at={due_at}
              local_task_id={local_task_id}
              asset_id={asset_id}
              asset_type={asset_type}
              related_to_task_ids={related_to_task_ids}
              tag_ids={tag_ids}
              tags={tags}
              description={description}
              description_html={description_html}
              priority_id={priority_id}
              setActiveTask={setActiveTask}
              action={action}
              isActive={isActive}
              moveTaskToFeedback={moveTaskToFeedback}
              moveTaskToArchive={moveTaskToArchive}
              getAssignees={getAssignees}
              dragHandleProps={provided.dragHandleProps}
              multiSelect={multiSelect}
              unSelectAll={unSelectAll}
              selectedTaskList={selectedTaskList}
              comments={comments}
              hasScreenRecording={hasScreenRecording}
              viewGuestKanban={viewGuestKanban}
              canDrag={canDrag}
              guestVisible={guestVisible}
              title={title}
              site={site}
              url={url}
              ai_suggested_title={ai_suggested_title}
              original_copy_text={original_copy_text}
            />
          </div>
        );
      }}
    </Draggable>
  );
};

export default DNDCard;
